import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { User as action } from '../../redux/actions';

/**
 * Updates given user information
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const update = (properties) => {
  const props = assign(properties);
  const model = {
    Users: props.data.map(item => ({
      Username: item.username,
      Data: {
        Name: item.state.name,
        Password: item.state.password,
        Surname: item.state.surname,
        Username: item.state.username,
      },
    })),
  };

  fetch(endpoint('/update-users'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.update(model.Users));
        }
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default update;
